import React from 'react'
import { type LucideProps } from 'lucide-react'

const LuxPass: React.FC<LucideProps> = (props: LucideProps) => (
<svg
  width={16}
  height={25}
  viewBox="0 0 16 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M0.794652 22.882L0.878043 1.31213C0.880515 0.672817 1.46423 0.155054 2.17933 0.157818L14.4171 0.20513C15.1322 0.207895 15.7119 0.730179 15.7094 1.36947L15.626 22.9394C15.6235 23.5787 15.0398 24.0964 14.3247 24.0937L2.08698 24.0464C1.37185 24.0436 0.792181 23.5212 0.794652 22.882ZM14.8841 1.36628C14.885 1.13379 14.6742 0.943884 14.4142 0.942879L2.17643 0.895567C1.91638 0.894561 1.70413 1.08284 1.70323 1.31532L1.61984 22.8852C1.61894 23.1177 1.82973 23.3076 2.08978 23.3086L14.3275 23.3559C14.5876 23.3569 14.7998 23.1687 14.8007 22.9362L14.8841 1.36628Z"
    fill="#949494"
  />
  <path
    d="M5.79035 9.78371C5.79063 9.71371 5.81083 9.64422 5.85024 9.58369C5.91853 9.47882 6.0355 9.41577 6.16065 9.41625L10.3641 9.4325C10.4893 9.43299 10.6056 9.49694 10.6732 9.60233C10.7408 9.70781 10.7502 9.84029 10.6983 9.9542L8.57864 14.6111C8.51849 14.7432 8.3866 14.8277 8.2415 14.8272C8.09641 14.8266 7.96508 14.7411 7.90605 14.6085L5.82234 9.93535C5.80057 9.88696 5.79005 9.83527 5.79025 9.78372L5.79035 9.78371ZM9.79042 10.1681L6.72854 10.1562L8.24643 13.5602L9.79042 10.1681Z"
    fill="#949494"
  />
</svg>

)

export default LuxPass
